module.exports = __webpack_public_path__ + "img/561.99ba8014.jpg";